// Portal sections are distinct from the twelve Command Center view controls.
// External-app entries control this portal's launcher, never the other app's login.
export const PLATFORM_TOOLS = Object.freeze([
  ['today','Today',['/','/workspace','/platform-overview']],
  ['opportunities','Opportunities',['/command-center']],
  ['myworklist','My Worklist',['/my-worklist']],
  ['pricing','Pricing Engine',['/pricing']],
  ['bowleligibility','Bowl Eligibility',['/bowl-eligibility']],
  ['governingbodies','Governing Bodies',['/governing-bodies']],
  ['artwork','Artwork',['/artwork-studio']],
  ['orders','Orders',['/production','/customer-journey']],
  ['performance','Performance',['/performance']],
  ['tradedesk','Trade Desk',['/trade-desk']],
  ['reviews','Reviews',['/reviews']],
  ['builders','Product Builders',['/product-builders']],
  ['presentations','Presentations',['/presentations']],
  ['teamrooms','Team Meeting Rooms',['/team-rooms']],
  ['toptierteams','Top Tier Teams',['/top-tier-teams']],
  ['aitools','AI Tools',['/ai-tools']],
  ['bodycoverage','Body Coverage',['/body-coverage']],
  ['invisiblerecords','Invisible Records',['/invisible-records']],
  ['reconciliation','Reconciliation',['/reconciliation']],
  ['integrity','Championship Integrity',['/championship-integrity']],
  ['tam','TAM',['/tam','/tam-basis']],
  ['schooldirectory','School Directory',['/school-directory']],
  ['team','Team Management',['/team']],
].map(([key,label,paths])=>Object.freeze({id:`platform.${key}`,label,paths:Object.freeze(paths)})))
const routes=new Map(PLATFORM_TOOLS.flatMap(tool=>tool.paths.map(path=>[path,tool.id])))
export const WORKSPACE_TOOL_IDS=Object.freeze({today:'platform.today',accounts:'platform.today',performance:'platform.performance',playbook:'platform.today'})
export function platformToolFor(location){
  const value=typeof location==='string'?location:`${location?.pathname||'/'}${location?.search||''}`
  let url
  try{url=new URL(value,'https://portal.invalid')}catch{return null}
  if(url.origin!=='https://portal.invalid')return null
  let path
  try{path=decodeURIComponent(url.pathname).toLowerCase().replace(/\/+$/,'')||'/'}catch{return null}
  if(path==='/'||path==='/workspace'||path==='/performance'){
    // Account journeys/playbook are part of Today; Performance is a separate module.
    const tab=url.searchParams.get('tab')||(path==='/performance'?'performance':'today')
    return WORKSPACE_TOOL_IDS[tab]||WORKSPACE_TOOL_IDS.today
  }
  if(/^\/invisible-records\/[^/]+$/.test(path))return 'platform.invisiblerecords'
  return routes.get(path)||null
}
export function platformAvailable(access,to){
  const id=platformToolFor(to)
  return Boolean(id&&access?.available(id))
}
